import React from "react";
import { useDesigner } from "./useDesigner";
import { DesignerMessages, getTypeName } from "./types";
import { AllContent, Content } from "../core/pdf/types";
import { useChannel } from "../core/hooks/useChannel";
import { pasteHtmlAtCaret } from "../core/utils/html";
import { useConditional } from "../core/hooks/useConditional";
import { FieldEditor } from "./FieldEditor";
import { ElementState } from "./useElementContext";
import { Icon } from "../core/ui/icons";
import { closestKey, closestKeyAsInt } from "../core/utils/dom";

export function StatusBar(props: {

}) {

	const designer = useDesigner();

	const [focused, setFocused] = React.useState<AllContent | undefined>();
	const [, refresh] = React.useState({});
	
	useChannel(designer.channel, React.useCallback((msg) => {
		if (msg.type === DesignerMessages.FOCUS_CHANGED) {
			setFocused(designer.focus);

		} else if (msg.type === DesignerMessages.FOCUS_REFRESH) {
			// forcing refresh
			refresh({});
			
		}
	}, [designer.focus]));

	let elementContext: ElementState | undefined;
	if (focused) {
		elementContext = designer.getContext(focused.id!);
	}

	const items: any[] = [];
	
	let o = elementContext;
	let i = 0;
	while (o && o.def) {
		const name = getTypeName(o.def.type);
		if (name) {
			if (items.length > 0) {
				items.splice(0, 0, <Icon key={"arrow-" + i} type="arrowRight" />);
			}

			items.splice(
				0, 0,
				<div key={o.def.id} className="node tag interactive" data-key={o.def.id}>{name}</div>
			);
		}

		o = o.parent;
		i++;
	}


	return (
		<div className="status-bar">
			<div
				className="context-nodes flex horiz gap-2"
				onClick={(e) => {
					const id = closestKeyAsInt(e.target, ".node");
					if (!id) return;

					const ref = designer.getRef(id);
					designer.setFocus(ref);
				}}
			>
				{items}
			</div>
		</div>
	);
}

